import styled from 'styled-components';

export const EmailAddress = styled.strong`
  color: ${({ theme }) => theme.colors.text.primary};
`;
